var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main",attrs:{"role":"main"}},[_c('div',{staticClass:"main_con"},[_c('div',{staticClass:"gift_list"},_vm._l((_vm.sections.content),function(section){return _c('benefitCard',{key:section.id,attrs:{"section":section},on:{"selectBenefit":_vm.goBenefit}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }